import { Column, Row } from "react-table"
import { Stack, Typography } from "@mui/material"
import SpotifyIcon from "../../../assets/images/social-media/spotify.png"
import GoogleDriveIcon from "../../../assets/images/social-media/google-drive.svg"
import Select from "react-select"
import { ReportUploadRequest, ReportUploadRequestStatus } from "types/reports"
import { KButton } from "kahuna-base-react-components"
import EyeIcon from "../../../assets/images/auth/eye.svg"

export const reportUploadRequestStatusOptions = [
  { label: "Upload In Progress", value: ReportUploadRequestStatus.UPLOAD_IN_PROGRESS },
  { label: "Upload Failed", value: ReportUploadRequestStatus.UPLOAD_FAILED },
  { label: "Upload Partial Success", value: ReportUploadRequestStatus.UPLOAD_PARTIAL_SUCCESS },
  { label: "Draft", value: ReportUploadRequestStatus.DRAFT },
  { label: "Reviewing", value: ReportUploadRequestStatus.REVIEWING },
  { label: "Request Approved", value: ReportUploadRequestStatus.REQUEST_APPROVED },
  { label: "Request Disapproved", value: ReportUploadRequestStatus.REQUEST_DISAPPROVED }
]

const reportUploadRequestTableColumns = (onViewReportUploadRequest: (item: ReportUploadRequest) => void): Column[] => [
  {
    id: "view",
    width: "3%",
    Cell: ({ row }: { row: Row }) => {
      return (
        <KButton
          width="20px"
          height="20px"
          padding="0px"
          icon={EyeIcon}
          onClick={() => {
            onViewReportUploadRequest(row.original as ReportUploadRequest)
          }}
          background="transparent"
          shadowDisabled={true}
        />
      )
    }
  },
  {
    Header: "Id",
    id: "id",
    width: "8%",
    Cell: ({ row }: { row: Row }) => (
      <Stack direction={"row"} alignItems={"center"}>
        {(row.original as ReportUploadRequest).id}
      </Stack>
    )
  },
  {
    Header: "User",
    id: "user",
    width: "20%",
    Cell: ({ row }: { row: Row }) => (
      <Stack direction={"row"} alignItems={"center"}>
        <Typography>
          <span className={"text-wrap"}>{(row.original as ReportUploadRequest).user.email}</span>
        </Typography>
      </Stack>
    )
  },
  {
    Header: "Type",
    accessor: "type",
    width: "10%",
    Cell: ({ row }: { row: Row }) => {
      const reportUploadRequest = row.original as ReportUploadRequest
      return <Typography>{reportUploadRequest.type.toUpperCase()}</Typography>
    }
  },
  {
    Header: "Artist",
    accessor: "spArtist",
    width: "17%",
    Cell: ({ row }: { row: Row }) => {
      const reportUploadRequest = row.original as ReportUploadRequest
      return (
        <div className="cursor-pointer" onClick={() => window.open(`/artists/${reportUploadRequest.artist.id}`)}>
          <Typography>{reportUploadRequest.artist?.name || reportUploadRequest.spotifyId}</Typography>
        </div>
      )
    }
  },
  {
    Header: "Spotify",
    id: "spotify",
    width: "5%",
    Cell: ({ row }: { row: Row }) => (
      <Stack direction={"row"} alignItems={"center"}>
        <div
          style={{ borderRadius: 40, padding: 8, backgroundColor: "white", marginRight: 12, cursor: "pointer" }}
          onClick={() =>
            window.open(`https://open.spotify.com/artist/${(row.original as ReportUploadRequest).spotifyId}`)
          }
        >
          <img style={{ width: 20 }} src={SpotifyIcon} alt={`spotify_image_icon`} />
        </div>
      </Stack>
    )
  },
  {
    Header: "Drive Folder",
    accessor: "sheetUrl",
    width: "8%",
    Cell: ({ row }: { row: Row }) => (
      <div
        style={{ borderRadius: 40, marginRight: 12, cursor: "pointer" }}
        onClick={() =>
          window.open(`https://drive.google.com/drive/folders/${(row.original as ReportUploadRequest).driveFolderId}`)
        }
      >
        <img style={{ width: 20 }} src={GoogleDriveIcon} alt={`google_drive_image_icon`} />
      </div>
    )
  },
  {
    Header: "Royalty Report Sheet",
    accessor: "royaltyReportSheetUrl",
    width: "9%",
    Cell: ({ row }: { row: Row }) =>
      (row.original as ReportUploadRequest)?.royaltyReportSheetId ? (
        <div
          style={{ borderRadius: 40, marginRight: 12, cursor: "pointer" }}
          onClick={() =>
            window.open(
              `https://docs.google.com/spreadsheets/d/${(row.original as ReportUploadRequest)?.royaltyReportSheetId}`
            )
          }
        >
          <img style={{ width: 20 }} src={GoogleDriveIcon} alt={`google_drive_image_icon`} />
        </div>
      ) : (
        <div />
      )
  },
  {
    Header: "Status",
    accessor: "status",
    width: "18%",
    Cell: ({ row }: { row: Row }) => {
      const spa = row.original as ReportUploadRequest
      const defaultValue = reportUploadRequestStatusOptions.find((option) => option.value === spa.status) || {
        label: spa.status,
        value: spa.status
      }
      return (
        <div style={{ width: 200, position: "relative" }}>
          <Select
            className="basic-single"
            classNamePrefix="select"
            defaultValue={defaultValue}
            name="Status"
            placeholder={"Select Status..."}
            options={reportUploadRequestStatusOptions}
            onChange={(selected) => {
              //onUpdateStatus(spa.id, selected.value, "status")
            }}
            isDisabled={true}
            styles={{
              menu: (provided) => ({
                ...provided,
                position: "relative"
              })
              /*control: (base, state) => ({
                ...base,
                backgroundColor: "#FFF",
                color: "#000",
                opacity: 1,
                cursor: "not-allowed"
              })*/
            }}
          />
        </div>
      )
    }
  },
  {
    Header: "Distributor",
    accessor: "distributor",
    width: "5%",
    Cell: ({ row }: { row: Row }) => <Typography>{(row.original as ReportUploadRequest).distributor}</Typography>
  },
  {
    Header: "Created",
    accessor: "created",
    width: "5%",
    Cell: ({ row }: { row: Row }) => (
      <Typography>{(row.original as ReportUploadRequest).created.substring(0, 10)}</Typography>
    )
  }
]

export default reportUploadRequestTableColumns
